import {ENV} from '@/interface';

interface SocketConfig {
  currentEnv: string | undefined;
  baseUrls: Record<ENV, string>;
  socketUrl: {
    ws: string;
  };
}
const {REACT_APP_ENV, REACT_APP_SOCKET_LOC, REACT_APP_SOCKET_DEV, REACT_APP_SOCKET_QA, REACT_APP_SOCKET_UAT, REACT_APP_SOCKET_PROD} = process.env;
export const SOCKET: SocketConfig = {
  currentEnv: REACT_APP_ENV,
  baseUrls: {
    loc: REACT_APP_SOCKET_LOC as string,
    dev: REACT_APP_SOCKET_DEV as string,
    prod: REACT_APP_SOCKET_PROD as string,
    qa: REACT_APP_SOCKET_QA as string,
    uat: REACT_APP_SOCKET_UAT as string,
  },

  socketUrl: {
  ws: 'api/v1/ws',
  }
};
